/**
 * Linearly interpolates between two values based on the input's position within
 * a range.
 *
 * @param   {number}  currentValue The current input value to interpolate.
 * @param   {number}  rangeStart   The start of the input range.
 * @param   {number}  rangeEnd     The end of the input range.
 * @param   {number}  startValue   The output value corresponding to the start
 *                                 of the input range.
 * @param   {number}  endValue     The output value corresponding to the end of
 *                                 the input range.
 * @returns {number}  The interpolated value based on the current input's
 *                    position within the range.
 */
module.exports = function lerp(currentValue, rangeStart, rangeEnd, startValue, endValue) {
    // Ensure currentValue is within the bounds of rangeStart and rangeEnd
    if (currentValue <= rangeStart) {
        return startValue;
    }

    if (currentValue >= rangeEnd) {
        return endValue;
    }

    // Perform the linear interpolation
    return startValue + (currentValue - rangeStart) * (endValue - startValue) / (rangeEnd - rangeStart);
};
